module.exports = __webpack_public_path__ + "images/defaultBanner.d7cf784d525a9ec138f1e4708c76a3d2.jpg";